var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Settings_Icon",
    "data-name": "Settings Icon",
    transform: "translate(-210 -173)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    width: 24,
    height: 24,
    transform: "translate(210 173)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(211 174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M21.1,15.6l2.75-.75a11.5,11.5,0,0,0,0-3.7L21.1,10.4a.9.9,0,0,1-.55-1.3l1.4-2.5A10.3,10.3,0,0,0,19.4,4.05l-2.5,1.4-.4.1a.9.9,0,0,1-.9-.65l-.75-2.75a11.5,11.5,0,0,0-3.7,0L10.4,4.9a.9.9,0,0,1-.9.65l-.4-.1L6.6,4.05A10.3,10.3,0,0,0,4.05,6.6l1.4,2.5a.9.9,0,0,1-.55,1.3l-2.75.75a11.5,11.5,0,0,0,0,3.7l2.75.75a.9.9,0,0,1,.55,1.3l-1.4,2.5A10.3,10.3,0,0,0,6.6,21.95l2.5-1.4.4-.1a.9.9,0,0,1,.9.65l.75,2.75a11.5,11.5,0,0,0,3.7,0l.75-2.75a.9.9,0,0,1,.9-.65l.4.1,2.5,1.4a10.3,10.3,0,0,0,2.55-2.55l-1.4-2.5a.9.9,0,0,1,.55-1.3Zm-.6-1.95h-.1a3.05,3.05,0,0,0-1.7,1.65,2.85,2.85,0,0,0,.05,2.4h.05v.1l.75,1.25a1.5,1.5,0,0,1-.4.4L17.9,18.7h-.15a2.7,2.7,0,0,0-1.25-.3,3,3,0,0,0-2.8,1.95v.15h0L13.25,22h-.5l-.4-1.45h0v-.1a3,3,0,0,0-2.85-2,2.7,2.7,0,0,0-1.25.3H8.1l-1.25.75a1.5,1.5,0,0,1-.4-.4l.75-1.25v-.1h.05a2.85,2.85,0,0,0,.05-2.4A3.05,3.05,0,0,0,5.6,13.7H5.45L4,13.25v-.5l1.45-.4H5.6A3.05,3.05,0,0,0,7.3,10.7a2.85,2.85,0,0,0-.05-2.4H7.2V8.2L6.45,6.95l.4-.4L8.1,7.3h.15a2.7,2.7,0,0,0,1.25.3,3,3,0,0,0,2.8-1.95V5.5h0L12.75,4h.5l.4,1.45h0v.1a3,3,0,0,0,2.85,2,2.7,2.7,0,0,0,1.25-.3h.15l1.25-.75a1.5,1.5,0,0,1,.4.4L18.8,8.15v.1h-.05a2.85,2.85,0,0,0-.05,2.4,3.05,3.05,0,0,0,1.7,1.65h.15l1.45.4v.5l-1.45.4Z",
    transform: "translate(-2 -2)",
    fill: "#2666cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M19.5,15A4.5,4.5,0,1,0,24,19.5,4.5,4.5,0,0,0,19.5,15Zm0,7A2.5,2.5,0,1,1,22,19.5,2.5,2.5,0,0,1,19.5,22Z",
    transform: "translate(-8.5 -8.5)",
    fill: "#2666cf"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.6f30e1a66d94b77d3e6607f9bc04cb14.svg";
export { ForwardRef as ReactComponent };